

export class ChartController {

    constructor(store) {
        this.store = store;
        this.container = document.createElement("div");
        this.container.className = 'flex width-100 height-100 justify-center'
        this.container.id = 'CHARTCONTAINER';
        this.plantWrapper = document.createElement("div");
        this.plantWrapper.className = this.store.config.isSmall ? 'flex width-100 height-10 font-16 color-50 justify-center' : 'flex width-100 height-10 font-25 color-50 justify-center'
        this.plantWrapper.id = 'PLANTWRAPPER'
        this.rolldownWrapper = document.createElement("div");
        this.rolldownWrapper.className = 'flex width-100 height-30 font-25 color-50 justify-center'
        this.rolldownWrapper.id = 'ROLLDOWNWRAPPER'
        this.yearWrapper = document.createElement("div");
        this.yearWrapper.className = this.store.config.isSmall ? 'flex column width-90 height-10 font-16 color-50 align-center margin-bottom-10' : 'flex column width-100 height-10 font-25 color-50 align-center margin-bottom-5'
        this.yearWrapper.id = 'YEARWRAPPER'
    }

    render() {
        this.container.innerHTML = "";
        const chartContainer = document.createElement("div");
        chartContainer.className = "flex column width-100 height-100 align-center";

        const view = document.createElement("div");
        view.textContent = 'Válassz nézetet';
        view.className = this.store.config.isSmall ? "flex width-90 height-10 font-20 color-50 justify-center" : "flex width-90 height-10 font-25 color-50 justify-center";

        // Körzetek / Települések kapcsoló
        const input = document.createElement("input");
        input.className = 'form-input justify-center'
        input.type = "checkbox";
        input.id = "area-switch";
        input.checked = false; // false = Körzetek, true = Települések
        const wrapper = document.createElement("div");
        wrapper.className = this.store.config.isSmall ?  "flex width-90 height-10 font-16 color-50 justify-center" : "flex width-90 height-10 font-25 color-50 justify-center";
        const left = document.createElement("span");
        left.className = "margin-right-5";
        left.textContent = "KÖRZETEK";
        const switchLabel = document.createElement("label");
        switchLabel.className = "switch";
        const slider = document.createElement("span");
        slider.className = "slider";
        switchLabel.appendChild(input);
        switchLabel.appendChild(slider);
        const right = document.createElement("span");
        right.className = "margin-left-5";
        right.textContent = "TELEPÜLÉSEK";
        wrapper.appendChild(left);
        wrapper.appendChild(switchLabel);
        wrapper.appendChild(right);

       
        this.plantWrapper.textContent = 'Válassz kultúrát';
        this.viewType = 'district';
        input.addEventListener("change", () => {
            const type = input.checked ? "city" : "district";
            this.viewType = type;
        });
        this.loadData(chartContainer);

        chartContainer.appendChild(view);
        chartContainer.appendChild(wrapper);
        chartContainer.appendChild(this.plantWrapper);
        this.container.appendChild(chartContainer);
        return this.container;
    }


    async buildRolldowns() {
        await this.store.datas.load('TERA')
        this.teraRolldown = [...new Set(this.store.database.tera.map(field => field.plant))].map(plant => ({key: plant, value: plant}));
        this.teraRolldown.unshift({key: '', value: 'válassz!'})
    }

    async loadData(chartContainer) {
        this.plantList = [];
        await this.buildRolldowns();

        const selectWrapper1 = document.createElement("div");
        selectWrapper1.className = "flex column width-30 height-20 align-center";
        selectWrapper1.id = 'SELECTWRAPPER1'

        const select1Title = document.createElement("div");
        select1Title.textContent = 'Első növény';
        select1Title.className = this.store.config.isSmall ? "font-14 color-50 margin-bottom-5" : "font-20 color-50 margin-bottom-5";

        const selectPlant1 = document.createElement("select");
        selectPlant1.className = 'form-input margin-bottom-10';
        this.teraRolldown.forEach(option => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.value;
            selectPlant1.appendChild(opt);
        });
        const selected1 = document.createElement("div");
        selected1.textContent = selectPlant1.value;
        selected1.className = this.store.config.isSmall ? "font-15" : "font-25";
        if (selectPlant1.value === "válassz!") {selected1.style.display = "none";}
        selectPlant1.addEventListener("change", () => {
            selected1.textContent = selectPlant1.value;
            selected1.style.display = selectPlant1.value === "válassz!" ? "none" : "";
            this.updateLists([selectPlant1, selectPlant2, selectPlant3], null);
        });
        
        selectWrapper1.appendChild(select1Title);
        selectWrapper1.appendChild(selectPlant1);
        selectWrapper1.appendChild(selected1);
        this.rolldownWrapper.appendChild(selectWrapper1);


        const selectWrapper2 = document.createElement("div");
        selectWrapper2.className = "flex column width-30 height-20 align-center";
        selectWrapper2.id = 'SELECTWRAPPER2'

        const select2Title = document.createElement("div");
        select2Title.textContent = 'Második növény';
        select2Title.className = this.store.config.isSmall ? "font-14 color-50 margin-bottom-5" : "font-20 color-50 margin-bottom-5";

        const selectPlant2 = document.createElement("select");
        selectPlant2.className = 'form-input margin-bottom-10';
        this.teraRolldown.forEach(option => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.value;
            selectPlant2.appendChild(opt);
        });
        const selected2 = document.createElement("div");
        selected2.textContent = selectPlant2.value;
        selected2.className = this.store.config.isSmall ? "font-15" : "font-25";
        if (selectPlant2.value === "válassz!") {selected2.style.display = "none";}
        selectPlant2.addEventListener("change", () => {
            selected2.textContent = selectPlant2.value;
            selected2.style.display = selectPlant2.value === "válassz!" ? "none" : "";
            this.updateLists([selectPlant1, selectPlant2, selectPlant3], null);
        });
        
        selectWrapper2.appendChild(select2Title);
        selectWrapper2.appendChild(selectPlant2);
        selectWrapper2.appendChild(selected2);
        this.rolldownWrapper.appendChild(selectWrapper2);

        const selectWrapper3 = document.createElement("div");
        selectWrapper3.className = "flex column width-30 height-20 align-center";
        selectWrapper3.id = 'SELECTWRAPPER3'

        const select3Title = document.createElement("div");
        select3Title.textContent = 'Harmadik növény';
        select3Title.className = this.store.config.isSmall ? "font-14 color-50 margin-bottom-5" : "font-20 color-50 margin-bottom-5";

        const selectPlant3 = document.createElement("select");
        selectPlant3.className = 'form-input margin-bottom-10';
        this.teraRolldown.forEach(option => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.value;
            selectPlant3.appendChild(opt);
        });
        const selected3 = document.createElement("div");
        selected3.textContent = selectPlant3.value;
        selected3.className = this.store.config.isSmall ? "font-15" : "font-25";
        if (selectPlant3.value === "válassz!") {selected3.style.display = "none";}
        selectPlant3.addEventListener("change", () => {
            selected3.textContent = selectPlant3.value;
            selected3.style.display = selectPlant3.value === "válassz!" ? "none" : "";
            this.updateLists([selectPlant1, selectPlant2, selectPlant3], null);
        });
        
        selectWrapper3.appendChild(select3Title);
        selectWrapper3.appendChild(selectPlant3);
        selectWrapper3.appendChild(selected3);
        this.rolldownWrapper.appendChild(selectWrapper3);

        chartContainer.appendChild(this.rolldownWrapper);

   
     // Évek
    const year = document.createElement("div");
    year.textContent = "Válassz éveket";
    const optionswrapper = document.createElement("div");
    optionswrapper.className = "flex row width-100 height-100 justify-center";
    const yearOptions = document.createElement("div");
    yearOptions.className = "flex row width-100 height-100 justify-evenly";
    this.yearOptions = yearOptions;

    [2020, 2021, 2022, 2023, 2024, 2025, 2026].forEach(yearValue => {
        const label = document.createElement("label");
        label.className = this.store.config.isSmall ? "font-12 margin-right-2" : "font-20 margin-right-1";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.className = 'form-checkbox'
        checkbox.name = "year";
        checkbox.value = yearValue;
        const text = document.createElement("span");
        text.textContent = yearValue;
        label.appendChild(checkbox);
        label.appendChild(text);
        yearOptions.appendChild(label);
        // Kiválasztás változásának figyelése
        checkbox.addEventListener("change", () => {
            const selectedYears = [...yearOptions.querySelectorAll("input:checked")].map(input => input.value);
            this.updateLists(null, selectedYears)
        });
    });
    optionswrapper.appendChild(year);
    this.yearWrapper.appendChild(optionswrapper);
    this.yearWrapper.appendChild(yearOptions);

    chartContainer.appendChild(this.yearWrapper);
      
    const button = document.createElement("div");
    button.type = "submit";
    button.className = "width-10 height-10 transition";
    button.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="4" height="9" rx="1" fill="#4CAF50"/>
            <rect x="10" y="6" width="4" height="14" rx="1" fill="#2196F3"/>
            <rect x="16" y="3" width="4" height="17" rx="1" fill="#FF9800"/>
        </svg>
    `;
    button.addEventListener("mouseenter", () => {button.style.transform = "scale(1.3)"});
    button.addEventListener("mouseleave", () => {button.style.transform = "scale(1)"});
    button.addEventListener("click", () => {
        if(this.viewType === 'district'){this.buildDistrictLists({viewType: this.viewType, plantList: this.plantList, selectedYears: this.selectedYears})
        }else{this.buildCityLists({viewType: this.viewType, plantList: this.plantList, selectedYears: this.selectedYears})}
        
    });
    
    chartContainer.appendChild(button);
        
    }

    async buildDistrictLists(props) {
        let chartArray = []
        const result = this.store.database.headoffices.map(office => {
            const districtid = office.districtid;
            const district = { districtid, plants: {}};
            if(props.plantList.length != 1){
                this.store.level.chartType = 'DISTRICTPLANTS'
                props.plantList.forEach(plant => {
                    const data = this.store.database.tera.filter(item => item.districtid === districtid && item.plant === plant);
                    district.plants[plant] = {};
                    const year = props.selectedYears[0];
                    const yearField = `year${year}`;
                    district.plants[plant][props.selectedYears[0]] = data.reduce((sum, item) => {return sum + (Number(item[yearField]) || 0);}, 0);
                });
                chartArray.push(district)
            }else{
                props.plantList.forEach(plant => {
                    this.store.level.chartType = 'DISTRICTYEARS'
                    const data = this.store.database.tera.filter(item => item.districtid === districtid && item.plant === plant);
                    district.plants[plant] = {};
                    props.selectedYears.forEach(year => {
                        const yearField = `year${year}`;
                        district.plants[plant][year] = data.reduce((sum, item) => {return sum + (Number(item[yearField]) || 0);}, 0);
                    });
                });
                chartArray.push(district)
            }
            
        });
        this.setMinMax(chartArray)
        this.store.level.chartArray = chartArray;
        this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
        this.store.levelController.setLevel({name: "CHART", hit: null});
    }

    async buildCityLists(props) {
        let chartArray = []
        await this.store.datas.load('CITIES')
        const result = this.store.database.cities.map(city => {
            const cityid = city.id;
            const actualCity = { cityid, plants: {}};
            
            if(props.plantList.length != 1){
                this.store.level.chartType = 'CITYPLANTS'
                props.plantList.forEach(plant => {
                    const data = this.store.database.tera.filter(item => item.cityid === cityid && item.plant === plant);
                    actualCity.plants[plant] = {};
                    const year = props.selectedYears[0];
                    const yearField = `year${year}`;
                    if (data.length > 0) {
                        const value = Number(data[0][yearField]);
                        if (Number.isFinite(value) && value !== 0) {actualCity.plants[plant][year] = value;}
                    }
                });
                chartArray.push(actualCity)
            }else{
                props.plantList.forEach(plant => {
                    this.store.level.chartType = 'CITYYEARS'
                    const data = this.store.database.tera.filter(item => item.cityid === city.id && item.plant === plant);
                    actualCity.plants[plant] = {};
                    
                    props.selectedYears.forEach(year => {
                        const yearField = `year${year}`;
                        if (data.length > 0) {
                        const value = Number(data[0][yearField]);
                        if (Number.isFinite(value) && value !== 0) {actualCity.plants[plant][year] = value;}
                    }
                    });
                });
                chartArray.push(actualCity)
            }
            
        });
        this.setMinMax(chartArray)
        this.store.level.chartArray = chartArray;
        this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
        this.store.levelController.setLevel({name: "CHARTCITY", hit: null});
        
    }

    updateLists(selects = null, years = null) {
        if (selects !== null) {
            this.plantList = selects.map(select => select.value).filter(value => value !== "válassz!" && value !== "");
            // Ha több növény van, legfeljebb egy év maradhat kiválasztva
            if (this.plantList.length > 1 && this.selectedYears?.length > 1) {this.selectedYears = [];}
        }

        if (years !== null) {
            this.selectedYears = years;
            const multiplePlants = this.plantList.length > 1;
            this.yearOptions.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {checkbox.disabled = multiplePlants && this.selectedYears.length >= 1 && !checkbox.checked;});
        }
    }

    setMinMax(chartArray) {
        let min = Infinity;
        let max = -Infinity;
        chartArray.forEach(element => {
            Object.entries(element.plants).forEach(([key, value]) => {
                Object.entries(value).forEach(([key, value]) => {
                    value = Number(value);
                    if(value < min){min = parseInt(value)}
                    if(value > max){max = parseInt(value)}
                    
                });
            });
        })
        if(min === 0){min = 1};
        this.store.level.chartMin = min;
        this.store.level.chartMax = max;
    }

    clearChart() {this.store.level.chartArray = [];}
}